import React, { useState } from 'react';
import { Container, Typography, Card, CardContent, Box, Stack, TextField, Button, CircularProgress } from '@mui/material';
import { api } from '../api'; // We just need the central 'api' client

const NewsPage = ({ state, refreshData }) => {
    const [query, setQuery] = useState('JazzCash');
    const [isSearching, setIsSearching] = useState(false);

    const handleSearch = async (e) => {
        e.preventDefault(); // Prevent form submission from reloading the page
        if (!query) return;
        
        setIsSearching(true);
        
        try {
            // --- THIS IS THE FIX ---
            // Call the new, secure backend route from your Canvas (/api/news/fetch)
            const response = await api.post(`/news/fetch`, { query });
            
            alert(response.data.message);
            await refreshData(); // Refresh the whole app to show new mentions

        } catch (error) {
            console.error("News search error:", error);
            alert(error.response?.data?.message || 'Failed to fetch or save news articles.');
        } finally {
            setIsSearching(false);
        }
    };

    return (
        <Container maxWidth="md">
            <Typography variant="h4" gutterBottom>News Search</Typography>
            <Card>
                <CardContent>
                    <Typography variant="h6">Find Latest News</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Search for news about a topic. The articles will be fetched, analyzed by the backend, and added to your main 'Mentions' list.
                    </Typography>
                    <Box component="form" onSubmit={handleSearch} sx={{ display: 'flex', gap: 2, mt: 2, mb: 4 }}>
                        <TextField 
                            fullWidth 
                            label="Search Query" 
                            value={query} 
                            onChange={e => setQuery(e.target.value)} 
                        />
                        <Button 
                            type="submit" 
                            variant="contained" 
                            disabled={isSearching}
                            sx={{ minWidth: '150px' }} // Give the button a good size
                        >
                            {isSearching ? <CircularProgress size={24} color="inherit" /> : 'Search & Save'}
                        </Button>
                    </Box>
                    
                    {isSearching && (
                        <Stack direction="row" spacing={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress size={24} />
                            <Typography>Fetching and analyzing news...</Typography>
                        </Stack>
                    )}
                </CardContent>
            </Card>
        </Container>
    );
};

export default NewsPage;

